import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import './PlanScroller.css';
import SectionLabel from '../Common/SectionLabel';

import PlanImg1 from '../../Assets/Imgs/PlanImg1.png';
import PlanImg2 from '../../Assets/Imgs/PlanImg2.png';
import PlanImg3 from '../../Assets/Imgs/PlanImg3.png';
import PlanImg4 from '../../Assets/Imgs/PlanImg4.png';
import { supabase } from '../../supabase';

const PlanScroller = () => {
    const [isShowroomHovered, setIsShowroomHovered] = useState(false);
    const [isDriveHovered, setIsDriveHovered] = useState(false);
    const [isHubHovered, setIsHubHovered] = useState(false);
    const [isChargingHovered, setIsChargingHovered] = useState(false);


    const horizontalRef = useRef(null);
    const horizontalTriggerRef = useRef(null);

    useEffect(() => {
        const panels = gsap.utils.toArray(horizontalRef.current.children);
        
        const ctx = gsap.context(() => {
            gsap.to(panels, {
                xPercent: -100 * (panels.length - 1),
                ease: "none",
                scrollTrigger: {
                    trigger: horizontalTriggerRef.current,
                    pin: true, 
                    scrub: 1,
                    snap: 1 / (panels.length - 1),
                    start: "top top",
                    end: () => `+=${horizontalTriggerRef.current.offsetWidth * (panels.length - 1)}`,
                    invalidateOnRefresh: true
                }
            });
        });
    
        return () => ctx.revert();
    }, []);


      // ------------------------------------------------------------------------------------------------------------------------------- //


      //supabase fucntions

      const [content, setContent] = useState({});
      const [loading, setLoading] = useState(true);

      useEffect(() => {
        const fetchContent = async () => {
            const { data, error } = await supabase
                .from('siteContent')
                .select('content_key, content_value')
                .eq('page_name', 'landing');

            if (!error && data) {
                const contentMap = data.reduce((acc, item) => {
                    acc[item.content_key] = item.content_value;
                    return acc;
                }, {});
                setContent(contentMap);
            }
            setLoading(false);
        };

        fetchContent();
    }, []);

    

    return ( 
        <section className='Plan' ref={horizontalTriggerRef}>
            <div className='PlanHorizontalWrapper' ref={horizontalRef}>
                <div className={`PlanScreen ShowroomScreen ${isShowroomHovered ? "ShowroomScreenAnim" : ""}`} onMouseEnter={() => setIsShowroomHovered(true)}onMouseLeave={() => setIsShowroomHovered(false)}style={{ pointerEvents: 'auto' }}>
                    <div className='Animated' style={{ pointerEvents: 'none' }}>
                        <div className='White'></div>
                        <div className='MainGreen'></div>
                        <div className='SecGreen'></div>
                    </div>

                    <div className='ScreenContent'>
                        <SectionLabel SectionLabel={content.exp_label} />
                        <p className='SectionTitle'>
                            {content.exp_title}
                        </p>

                        <div className='ScreenText'>
                            <p className='ScreenNum'></p>
                            <p className='ScreenTitle'>
                                {content.exp_screen1_title}
                            </p>
                            <p className='ScreenSub'>
                                {content.exp_screen1_sub}
                            </p>
                        </div>

                    </div>

                    <img className='PlanImg' src={content.exp_img1} alt=''/>

                </div>

                <div className={`PlanScreen DriveScreen ${isDriveHovered ? "ShowroomScreenAnim" : ""}`} onMouseEnter={() => setIsDriveHovered(true)}onMouseLeave={() => setIsDriveHovered(false)}style={{ pointerEvents: 'auto' }}>
                    <div className='Animated' style={{ pointerEvents: 'none' }}>
                        <div className='White'></div>
                        <div className='MainGreen'></div>
                        <div className='SecGreen'></div>
                    </div>

                    <div className='ScreenContent'>
                        <SectionLabel SectionLabel={content.exp_label} />
                        <p className='SectionTitle'>
                            {content.exp_title}
                        </p>

                        <div className='ScreenText'>
                            <p className='ScreenNum'></p>
                            <p className='ScreenTitle'>
                                {content.exp_screen2_title}
                            </p>
                            <p className='ScreenSub'>
                                {content.exp_screen2_sub}
                            </p>
                        </div>

                    </div>

                    <img className='PlanImg' src={content.exp_img2} alt=''/>

                </div>

                <div className={`PlanScreen HubScreen ${isHubHovered ? "ShowroomScreenAnim" : ""}`} onMouseEnter={() => setIsHubHovered(true)}onMouseLeave={() => setIsHubHovered(false)}style={{ pointerEvents: 'auto' }}>
                    <div className='Animated' style={{ pointerEvents: 'none' }}>
                        <div className='White'></div>
                        <div className='MainGreen'></div>
                        <div className='SecGreen'></div>
                    </div>

                    <div className='ScreenContent'>
                        <SectionLabel SectionLabel={content.exp_label} />
                        <p className='SectionTitle'>
                            {content.exp_title}
                        </p>

                        <div className='ScreenText'>
                            <p className='ScreenNum'></p>
                            <p className='ScreenTitle'>
                                {content.exp_screen3_title}
                            </p>
                            <p className='ScreenSub'>
                                {content.exp_screen3_sub}
                            </p>
                        </div>

                    </div>

                    <img className='PlanImg' src={content.exp_img3} alt=''/>

                </div>

                <div className={`PlanScreen ChargingScreen ${isChargingHovered ? "ShowroomScreenAnim" : ""}`} onMouseEnter={() => setIsChargingHovered(true)}onMouseLeave={() => setIsChargingHovered(false)}style={{ pointerEvents: 'auto' }}>
                    <div className='Animated' style={{ pointerEvents: 'none' }}>
                        <div className='White'></div>
                        <div className='MainGreen'></div>
                        <div className='SecGreen'></div>
                    </div>

                    <div className='ScreenContent'>
                        <SectionLabel SectionLabel={content.exp_label} />
                        <p className='SectionTitle'>
                            {content.exp_title}
                        </p>

                        <div className='ScreenText'>
                            <p className='ScreenNum'></p>
                            <p className='ScreenTitle'>
                                {content.exp_screen4_title}
                            </p>
                            <p className='ScreenSub'>
                                {content.exp_screen4_sub}
                            </p>
                        </div>

                    </div>

                    <img className='PlanImg' src={content.exp_img4} alt=''/>

                </div>
            </div>
        </section>
    );
}

export default PlanScroller;